import { Input } from '@panwds/react-form'
import { Body, Bold, Button, Tooltip } from '@panwds/react-ui'
import { useFormContext } from 'react-hook-form'
import { InfoIcon } from '@panwds/icons'


export interface ITextBoxProps {
  placeholder?: string;
  name: string;
  label: string;
  disable?: boolean;
  showLabel?: boolean;
  tooltip?: string;
  validation?: (value: string) => string | boolean
}

const TextBox = (props: ITextBoxProps) => {
  const { trigger } = useFormContext()
  const {
    placeholder,
    name,
    showLabel,
    label,
    validation,
    tooltip = '',
    disable = false
  } = props

  return (
    <div>
      <div className='tw-flex tw-flex-row'>
        <Body size="sm" addClassName='tw-items-center tw-py-2 tw-pl-1'><Bold appearance="semibold">{label}</Bold></Body>
        <Tooltip
          label={tooltip}
        >
          <div className='tw-flex tw-items-center'>
            <Button
              size='sm'
              aria-label='contract-button'
              icon={<InfoIcon size="xs" className="tw-text-icon-gray" />}
              appearance='clear'
              style={{ background: 'transparent' }}
            />
          </div>
        </Tooltip>
      </div>
      <div className='tw-flex tw-flex-row'>
        <Input
          placeholder={placeholder}
          addClassName="tw-w-70"
          name={name}
          label={showLabel ? label : ''}
          disabled={disable}
          showLabel={showLabel}
          register={{
            required: false,
            onChange: ((e) => {
              trigger(name)
            }),
            validate: validation
          }}
        />
      </div>
    </div>)

}
export default TextBox
